import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FacilityPatientSearchResultDto, FpSearchParametersDto } from 'webcommon/shared';
import { FacilityPortalHttpClientService } from '../FacilityPortalHttpClientService';

@Injectable({
  providedIn: 'root',
})
export class FacilityPatientRepository {

  constructor(
    private httpClientService: FacilityPortalHttpClientService,
  ) { }

  getPatients(searchCriteria: FpSearchParametersDto): Observable<FacilityPatientSearchResultDto[]> {
    const endpointUrl = `patients`;
    return this.httpClientService.sendPostRequest(endpointUrl, searchCriteria);
  }
}
